import styled from "styled-components";
import { Link } from "react-router-dom";

export const Button = styled(Link)`
    border-radius: 16px;
    background: ${({primary}) => (primary ? '#38A7BA' : '#010606')};
    white-space: nowrap;
    padding: ${({big}) => (big ? '16px 32px' : '14px 28px')};
    color: ${({dark}) => (dark ? '#010606' : '#ffffff')};
    font-size: ${({fontBig}) => (fontBig ? '16px' : '15px')};
    font-weight: 500;
    outline: none;
    border: none;
    cursor: pointer;
    display: ${({appear}) => (appear ? 'inline-flex' : 'none')};
    justify-content: center;
    align-items: center;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    text-decoration: none;
    margin-top: 8px;
    margin-right: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    letter-spacing: 0.3px;
    border: 1px solid transparent;

    &:hover {
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        background: ${({primary}) => (primary ? '#2E8A99' : '#38A7BA')};
        color: #fff;
        transform: translateY(-2px);
        box-shadow: 0 8px 24px rgba(56, 167, 186, 0.3);
        border-color: #38A7BA;
    }

    &:active {
        transform: translateY(-1px);
        box-shadow: 0 4px 16px rgba(56, 167, 186, 0.2);
    }

    @media screen and (max-width: 768px) {
        padding: ${({big}) => (big ? '14px 28px' : '12px 24px')};
        font-size: ${({fontBig}) => (fontBig ? '15px' : '14px')};
        margin-right: 10px;
    }

    @media screen and (max-width: 480px) {
        padding: ${({big}) => (big ? '12px 24px' : '10px 20px')};
        font-size: ${({fontBig}) => (fontBig ? '14px' : '13px')};
        margin-right: 8px;
        margin-top: 6px;
    }
`;

export const ButtonLink = styled.a`
    border-radius: 16px;
    background: ${({primary}) => (primary ? '#38A7BA' : '#010606')};
    white-space: nowrap;
    padding: ${({big}) => (big ? '16px 32px' : '14px 28px')};
    color: ${({dark}) => (dark ? '#010606' : '#ffffff')};
    font-size: ${({fontBig}) => (fontBig ? '16px' : '15px')};
    font-weight: 500;
    outline: none;
    border: none;
    cursor: pointer;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    text-decoration: none;
    margin-top: 8px;
    margin-right: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    letter-spacing: 0.3px;
    border: 1px solid transparent;

    &:hover {
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        background: ${({primary}) => (primary ? '#2E8A99' : '#38A7BA')};
        color: #fff;
        transform: translateY(-2px);
        box-shadow: 0 8px 24px rgba(56, 167, 186, 0.3);
        border-color: #38A7BA;
    }

    &:active {
        transform: translateY(-1px);
        box-shadow: 0 4px 16px rgba(56, 167, 186, 0.2);
    }

    @media screen and (max-width: 768px) {
        padding: ${({big}) => (big ? '14px 28px' : '12px 24px')};
        font-size: ${({fontBig}) => (fontBig ? '15px' : '14px')};
        margin-right: 10px;
    }

    @media screen and (max-width: 480px) {
        padding: ${({big}) => (big ? '12px 24px' : '10px 20px')};
        font-size: ${({fontBig}) => (fontBig ? '14px' : '13px')};
        margin-right: 8px;
        margin-top: 6px;
    }
`;